/**
 * @fileoverview GET handler for the "/companies/:company_id/verified_domains" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdVerifiedDomains } from "./constants";
import type {
  GetCompaniesCompanyIdVerifiedDomainsParams,
  GetCompaniesCompanyIdVerifiedDomainsResult,
} from "./types";
import { isGetCompaniesCompanyIdVerifiedDomainsResult } from "./validators";

export const getCompaniesCompanyIdVerifiedDomains = reactQueryFetcherAdapter(
  companiesCompanyIdVerifiedDomains,
  (
    signal: AbortSignal,
    companyId: string,
    params: GetCompaniesCompanyIdVerifiedDomainsParams
  ): Promise<GetCompaniesCompanyIdVerifiedDomainsResult> => {
    const { status = "all", start = 0, limit = 10 } = params ?? {};
    return fetch(
      `/companies/${companyId}/verified_domains`,
      "GET",
      {
        status,
        start,
        limit,
      },
      { signal }
    );
  },
  isGetCompaniesCompanyIdVerifiedDomainsResult
);
